import React from 'react';
import '../css/HomePage.css';

function HomePage() {
  return (
    <div className="container d-flex justify-content-center align-items-center">
      <div className="text-center bg-light p-5 rounded shadow-sm home-welcome-box">
        <h1 className="mb-3 text-primary">Welcome to Shipway's<br/> <b>JIRA Dashboard</b></h1>
        <p className="lead text-secondary">
          Track the team's progress and monitor sprint health.
        </p>
      </div>
    </div>
  );
}

export default HomePage;
